const namespaced = true

const defaultState = () => {
  return {
    setCreateModal: {
      show: false
    },
    setEditModal: {
      show: false,
      id: null
    }
  }
}

const state = defaultState()

const actions = {
  setIsCreateModalOpen({ commit }, payload) {
    commit('SET_CREATE_MODAL', payload)
  },
  setIsEditModalOpen({ commit }, payload) {
    commit('SET_EDIT_MODAL', payload)
  },
  resetState({ commit }) {
    commit('RESET_STATE')
  }
}

const mutations = {
  SET_CREATE_MODAL(state, payload) {
    state.setCreateModal = payload
  },
  SET_EDIT_MODAL(state, payload) {
    state.setEditModal = payload
  },
  RESET_STATE(state) {
    Object.assign(state, defaultState())
  }
}

export default {
  namespaced,
  state,
  mutations,
  actions
}
